/* eslint-disable react-hooks/exhaustive-deps */
import {useMemo, useState} from "react"
import {AppliedFilter, FilterKey, FilterList} from "types/filter"
import {CallLogStats, StudentCallLogFilter, StudentCallLogListView} from "./parts"
import moment from "moment"

type Props = {
    departmentId: number
    filterKey: FilterKey
    studentProfileId?: number
}

const INITIAL_FILTER: AppliedFilter = {
    search: "",
    filters: {}
}

export function CallLog(props: Props) {
    const {departmentId, filterKey, studentProfileId} = props
    const [appliedFilter, setAppliedFilter] = useState<AppliedFilter>()

    const onApplyFilter = (payload: AppliedFilter) => {
        setAppliedFilter(payload)
    }

    const filterParams = useMemo(() => {
        const {status, students, program, campus, createdAtRange, admAdvisors} = appliedFilter?.filters ?? {}

        let filter: FilterList = {}

        if (students) {
            filter.studentUserIds = {
                operator: students.operator,
                value: students.value.map(({id}) => id)
            }
        }
        if (program) {
            filter.programIds = {
                operator: program.operator,
                value: program.value.map(({id}) => id)
            }
        }
        if (campus) {
            filter.campusIds = {
                operator: campus.operator,
                value: campus.value.map(({id}) => id)
            }
        }
        if (status) {
            filter.status = {
                operator: status.operator,
                value: status.value.map(({id}) => id)
            }
        }
        if (createdAtRange) {
            filter.createdAtRange = {
                operator: createdAtRange.operator,
                value: Array.isArray(createdAtRange.value)
                    ? createdAtRange.value.map((v) => moment(v).format("YYYY-MM-DD"))
                    : moment(createdAtRange.value).format("YYYY-MM-DD")
            }
        }
        if (admAdvisors) {
            filter.admAdvisorProfileIds = {
                operator: admAdvisors.operator,
                value: admAdvisors.value.map((profile) => profile.profileId)
            }
        }

        return {
            filters: filter,
            search: appliedFilter?.search,
            studentProfileId: studentProfileId
        }
    }, [appliedFilter])

    return (
        <div>
            {!studentProfileId && <CallLogStats departmentId={departmentId} />}
            <StudentCallLogFilter
                filterKey={filterKey}
                initialFilter={INITIAL_FILTER}
                onApplyFilter={onApplyFilter}
                onClearFilter={() => onApplyFilter({filters: {}, search: ""})}
            />
            <StudentCallLogListView
                filterKey={filterKey}
                filterParams={filterParams}
                departmentId={departmentId}
                studentProfileId={studentProfileId}
            />
        </div>
    )
}
